
import { defineComponent } from 'vue';
import { mapStores } from 'pinia';
import Alert from 'client/components/LoginAlert.vue';
import EmailBadge from 'client/components/EmailBadge.vue';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginCard from 'client/components/LoginCard.vue';

import UserLoginStore from 'client/stores/UserLoginStore';

const REASON_ALLOW_UNENROLLED = 'ALLOW_UNENROLLED';
const REASON_FEATURE_DISABLED = 'FEATURE_DISABLED';

export default defineComponent({
  name: 'UserResetPasswordRequest',

  components: {
    Alert,
    EmailBadge,
    LoginCard,
    LoginActionButton,
  },

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapStores(UserLoginStore),

    email() {
      return this.userLoginStore.email;
    },

    eligibilityReason(): string | undefined {
      return this.userLoginStore.eligibility?.reason;
    },

    showTryAnotherMethod(): boolean {
      const { eligibility } = this.userLoginStore;
      if (!eligibility) {
        return false;
      }
      if (
        this.eligibilityReason === REASON_FEATURE_DISABLED
        || this.eligibilityReason === REASON_ALLOW_UNENROLLED
      ) {
        return false;
      }
      // eligible:true, NO_FACTORS, or eligible:false with no reason (anti-enumeration)
      return true;
    },
  },

  methods: {
    submit() {
      this.$emit('submit', this.email);
    },

    goToLogin() {
      this.$emit('goToLogin');
    },

    selectMfa() {
      this.$emit('selectMfa');
    },
  },
});

